type Props = {
  fill?: string;
  height: string;
  letterFill?: string;
  width: string;
};

const FacebookRoundIcon = ({
  fill = '#1877F2',
  height,
  letterFill,
  width
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 8.00002C14.6667 4.31811 11.6819 1.33335 8 1.33335C4.3181 1.33335 1.33333 4.31811 1.33333 8.00002C1.33333 11.3275 3.77124 14.0856 6.95833 14.5857V9.9271H5.26562V8.00002H6.95833V6.53127C6.95833 4.86043 7.95362 3.93752 9.47643 3.93752C10.2058 3.93752 10.9687 4.06772 10.9687 4.06772V5.70835H10.1281C9.29993 5.70835 9.04167 6.22224 9.04167 6.74945V8.00002H10.8906L10.5951 9.9271H9.04167V14.5857C12.2288 14.0856 14.6667 11.3275 14.6667 8.00002Z"
        fill={fill}
      />
      {letterFill && (
        <path
          d="M10.5951 9.92708L10.8906 8H9.04167V6.74944C9.04167 6.22223 9.29993 5.70833 10.1281 5.70833H10.9688V4.06771C10.9688 4.06771 10.2058 3.9375 9.47643 3.9375C7.95362 3.9375 6.95833 4.86042 6.95833 6.53125V8H5.26562V9.92708H6.95833V14.5857C7.29775 14.6389 7.64563 14.6667 8 14.6667C8.35438 14.6667 8.70225 14.6389 9.04167 14.5857V9.92708H10.5951Z"
          fill={letterFill}
        />
      )}
    </svg>
  );
};

export default FacebookRoundIcon;
